import React from 'react';
import PropTypes from 'prop-types';
import { compose, lifecycle, withHandlers, withState } from 'recompose';
import SimpleCurrencyInput from '../../../common/SimpleCurrency';
import { addBarberPayout, addShopPayout } from '../../cashRegister/actions';
import { withActionByRole } from '../../../common/helpers/actions';
import { t } from '../../../../modules/infra/i18n';

const CashTipsPayoutInput = props => (
  <div className="c-cash-tips-input">
    <span className="c-cash-tips-input__dollar-sign">$</span>
    <SimpleCurrencyInput
      className="c-cash-tips-input__input-field"
      value={props.payoutValue}
      disabled={props.isLoading}
      onInputChange={(e) => {
        props.setShowCompleted(false);
        props.setPayoutValue(e);
      }}
    />
    {
      props.showCompleted
        ? <span className="c-cash-tips-input__notification">{t('register:summary.cash_tips.completed')}</span>
        : <button
          onClick={props.payoutTips}
          disabled={props.isLoading}
          className="c-cash-tips-input__button"
        >
          {t('register:summary.cash_tips.payout_tips')}
        </button>
    }
  </div>
);

CashTipsPayoutInput.propTypes = {
  payoutValue: PropTypes.number.isRequired,
  setPayoutValue: PropTypes.func.isRequired,
  payoutTips: PropTypes.func.isRequired,
  showCompleted: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  setShowCompleted: PropTypes.func.isRequired,
};

export default compose(
  withState('payoutValue', 'setPayoutValue', props => props.tipsToPayout || 0),
  withState('showCompleted', 'setShowCompleted', false),
  withState('isLoading', 'setIsLoading', false),
  withActionByRole('addPayout', addShopPayout, addBarberPayout),
  withHandlers({
    payoutTips: props => () => {
      if (props.selectedBarber && props.payoutValue) {
        props.setIsLoading(true);
        props
          .addPayout({
            desc: t('register:summary.cash_tips.tip_payout_description', {
              firstName: props.selectedBarber.firstName,
              lastName: props.selectedBarber.lastName,
            }),
            amount: props.payoutValue,
          })
          .then(() => props.setShowCompleted(true))
          .finally(() => {
            props.setIsLoading(false);
          });
      }
    },
  }),
  lifecycle({
    componentDidUpdate(prevProps) {
      if (prevProps.tipsToPayout !== this.props.tipsToPayout) {
        this.props.setPayoutValue(this.props.tipsToPayout);
      }
    },
  })
)(CashTipsPayoutInput);
